import { render, staticRenderFns } from "./ProjectAdministration.vue?vue&type=template&id=4fc8850e&scoped=true&"
import script from "./ProjectAdministration.vue?vue&type=script&lang=js&"
export * from "./ProjectAdministration.vue?vue&type=script&lang=js&"
import style0 from "./ProjectAdministration.vue?vue&type=style&index=0&id=4fc8850e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc8850e",
  null
  
)

export default component.exports